import { RouteType } from "../../../types/RouteType";

const TrailerLoadBuilderRoute: RouteType = {
  name: "Trailer Load Builder",
  path: "/production/trailer-load-builder/:tab?",
  defaultParams: { tab: "trailer-config" },
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./components/TrailerHeader"),
      title: "Trailer Load Builder",
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./components/TrailerBody"),
      grayBackground: true,
    },
  },
  requiresAuth: true,
  requiresPermission: false,
  beforeEnter: async ({ rootStore }: { rootStore: any }) => {
    try {
      // Load available panels if panel store exists
      if (rootStore.panelStore) {
        await rootStore.panelStore.find({
          query: {
            loadNumber: null,
            $limit: 100,
          },
        });
      }

      // Load any saved configurations from local storage for now
      // Will be replaced with trailer-loads service
      const savedLoads = localStorage.getItem("trailerLoads");
      if (!savedLoads) {
        localStorage.setItem("trailerLoads", JSON.stringify([]));
      }

      return true;
    } catch (error) {
      console.error("Error loading trailer load builder data:", error);
      return true; // Allow entry even if data load fails
    }
  },

  onParamsChange: async ({
    params,
    rootStore,
  }: {
    params: any;
    rootStore: any;
  }) => {
    const viewStore = rootStore.trailerLoadViewStore;

    // Handle tab changes if needed
    if (
      params.tab &&
      ["trailer-config", "panel-selection"].includes(params.tab)
    ) {
      // Tab handling is done in the component
    }
  },

  onExit: ({ rootStore }: { rootStore: any }) => {
    // Clean up if needed
    const viewStore = rootStore.trailerLoadViewStore;
    if (viewStore) {
      viewStore.resetView();
    }
  },

  dialogs: [
    {
      name: "SaveLoadConfiguration",
      component: () => import("./dialogs/SaveLoadDialog"),
      title: "Save Load Configuration",
      height: 400,
      cancelButton: true,
      onSubmit: async ({ rootStore }: { rootStore: any }) => {
        const viewStore = rootStore.trailerLoadViewStore;
        const dialogData = rootStore.routerStore.dialogFormData;
        try {
          await viewStore.saveLoadConfiguration(
            dialogData.name,
            dialogData.notes
          );
          return true;
        } catch (error) {
          console.error("Error saving configuration:", error);
          return false;
        }
      },
      onSubmitValidation: ({ rootStore }: { rootStore: any }) => {
        const dialogData = rootStore.routerStore.dialogFormData;
        return !!(dialogData?.name && dialogData.name.trim());
      },
    },
    {
      name: "LoadConfiguration",
      component: () => import("./dialogs/LoadConfigDialog"),
      title: "Load Saved Configuration",
      height: 500,
      cancelButton: true,
      onSubmit: async ({ rootStore }: { rootStore: any }) => {
        const viewStore = rootStore.trailerLoadViewStore;
        const dialogData = rootStore.routerStore.dialogFormData;
        try {
          await viewStore.loadSavedConfiguration(dialogData.loadId);
          return true;
        } catch (error) {
          console.error("Error loading configuration:", error);
          return false;
        }
      },
      onSubmitValidation: ({ rootStore }: { rootStore: any }) => {
        const dialogData = rootStore.routerStore.dialogFormData;
        return !!dialogData?.loadId;
      },
    },
    {
      name: "ExportPDF",
      component: () => import("./dialogs/ExportPDFDialog"),
      title: "Export Load Plan PDF",
      height: 400,
      cancelButton: true,
      onSubmit: async ({ rootStore }: { rootStore: any }) => {
        const viewStore = rootStore.trailerLoadViewStore;
        try {
          // PDF export will be implemented in the dialog component
          return true;
        } catch (error) {
          console.error("Error exporting PDF:", error);
          return false;
        }
      },
    },
  ],
};

export default TrailerLoadBuilderRoute;
